module.exports = {
  screen: require('./screen.png'),
  loader: require('./loader.gif'),
  footer: require('./byAuteco.png'),
};
